module.exports = __webpack_public_path__ + "media/images/users/men-a54003ccf5f37d70f87322e3949c13eb.svg";